const CHUNK_SIZE = 200;

export const splitIntoChunks = (array: any[]) => {
  return array.reduce((result: any[][], item, index) => {
    const chunkIndex = Math.floor(index / CHUNK_SIZE);
    if (!result[chunkIndex]) {
      result[chunkIndex] = [];
    }
    result[chunkIndex].push(item);
    return result;
  }, []);
};
